// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___, * as ___CSS_LOADER_ICSS_IMPORT_0____NAMED___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].use[2]!../../../node_modules/@tcc/crate/src/StyleGuide/Colors/colors.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tableHeader__tableHeader {
  background-color: ${ ___CSS_LOADER_ICSS_IMPORT_0____NAMED___["silver"] };
  height: 3.5rem;
  text-align: left;
  position: sticky;
  top: 0;
  z-index: 1;
}

.tableHeader__tableHeaderCell {
  background-color: ${ ___CSS_LOADER_ICSS_IMPORT_0____NAMED___["silver"] };
  height: 3.5rem;
  font-size: 0.9rem;
}

.tableHeader__sortableTableHeaderCell {
  cursor: pointer;

  div {
    display: flex;
    align-items: center;
    gap: 6px;
  }
}

.tableHeader__ascSorting {
  transform: rotate(90deg);
}

.tableHeader__descSorting {
  transform: rotate(-90deg);
}
`, "",{"version":3,"sources":["webpack://./src/components/TableHeader/tableHeader.css"],"names":[],"mappings":"AAEA;EACE,8DAAwB;EACxB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,MAAM;EACN,UAAU;AACZ;;AAEA;EACE,8DAAwB;EACxB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,eAAe;;EAEf;IACE,aAAa;IACb,mBAAmB;IACnB,QAAQ;EACV;AACF;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":["@value silver from '@tcc/crate/src/StyleGuide/Colors/colors.css';\n\n.tableHeader {\n  background-color: silver;\n  height: 3.5rem;\n  text-align: left;\n  position: sticky;\n  top: 0;\n  z-index: 1;\n}\n\n.tableHeaderCell {\n  background-color: silver;\n  height: 3.5rem;\n  font-size: 0.9rem;\n}\n\n.sortableTableHeaderCell {\n  cursor: pointer;\n\n  div {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n  }\n}\n\n.ascSorting {\n  transform: rotate(90deg);\n}\n\n.descSorting {\n  transform: rotate(-90deg);\n}\n"],"sourceRoot":""}]);
// Exports
export var silver = `${___CSS_LOADER_ICSS_IMPORT_0____NAMED___["silver"]}`;
export var tableHeader = `tableHeader__tableHeader`;
export var tableHeaderCell = `tableHeader__tableHeaderCell`;
export var sortableTableHeaderCell = `tableHeader__sortableTableHeaderCell`;
export var ascSorting = `tableHeader__ascSorting`;
export var descSorting = `tableHeader__descSorting`;
export default ___CSS_LOADER_EXPORT___;
